import React from "react"
import { RespostasPersonalizadasIzzaContextProvider } from "./context/RespostasPersonalizadasIzzaContextProvider"
import { RespostasPersonalizadasIzzaPage } from "./RespostasPersonalizadasIzza"

export function Index() {
    return (
        <RespostasPersonalizadasIzzaContextProvider>
            <RespostasPersonalizadasIzzaPage />
        </RespostasPersonalizadasIzzaContextProvider>
    )
}
